import React,{useState,useEffect} from 'react';
import {Link} from 'react-router-dom';
import Pagination from '../components/Pagination';
import { MdError } from "react-icons/md";

import firebase from '../firebase/Firebase';



export default function Coperate(props) {

    const [category,setCategory] = useState("");
    const [posts,setPosts]= useState([]);
    const [isbusy,setisbusy] = useState(false);

    const [currentPage,setCurrentpage] = useState(1);
    const [postsPerPage,setPostsPerPage] = useState(9);
    
    const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];



    const getarticles = async (category)=>{
        setisbusy(true);
        const _post = await firebase.getrecommendedArticle(category).catch(err=>{
            console.log(err);
            return err;
        });

        setPosts(_post);
        setisbusy(false);
        


    }

    console.log(posts);
    
    useEffect(()=>{

        setCategory(props.match.params.category);
        getarticles(props.match.params.category);

        console.log(category);
    
    },[props.match.params.category]);


    


    const indexOfLastPost = currentPage* postsPerPage;
    const indexofFirstPost = indexOfLastPost- postsPerPage;

    const paginate = (pagenumber) =>{
        setCurrentpage(pagenumber);
    }
    let content;
    if(isbusy){
        content = (
            <div className="row latestcard">
            <div className=" col-12">
                

                <div className="card__description loading1"></div><br />
                <div className="card__description loading2"></div><br />

    
                <div className="card__description loading1"></div><br />
                <div className="card__description loading2"></div><br />
    

                
                
                
            </div>
            
            </div>

        )
    }else{

        if (posts.length == 0) {
            content=(
                <div className="error-size">
            <br/>
                <div className="jumbotron">
                <h1><MdError /> Oops! No such Articles found <MdError/></h1>
                
        </div>
        {/* <h3>Re-enter the URL or Contact-us for any help.</h3> */}
        </div>
            )
            
        }else{

        
        content =(

            

            
                   
                 <div className="row">
    {posts.slice(indexofFirstPost,indexOfLastPost).map((post,i) =>{
        return(
            <>
            
               <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12">
        <Link to={"/article/"+post.data.field+"/"+post.id} >

        <div class="card card-item snip1527">
             <div class="image">
              <img src={post.data.cover} alt="pr-sample23" />
             </div>
        <figcaption className="no-expand">
            
        
        <div class="date"><span class="day">{post.data.date.slice(3,5)}<br></br><p>{month[parseInt((post.data.date.slice(0,2)))-1]}</p></span></div>
            <h4> {post.data.name}</h4>
            <i class="fas fa-user"> &nbsp;{post.data.publishedBy}</i>
                 
        </figcaption>

        </div>
        </Link>
     </div>
               </>

        )
    })}
</div>

        


                


        )
}
    }





    return (
        <>

        {/* <div className="articleone">
            <div className="container">
                <div className="row">
                    <div className="offset-1 col-10 offset-1">



                    </div>
                </div>
            </div>
        </div> */}

           <div class="container">
              
              <div style={{marginTop: 50}}>
                   <div>
                 {content}

            </div>
             </div>

                 <Pagination totalposts={posts.length} postsperpage={postsPerPage} paginate={paginate} />
           </div>

           
        </>
    )
}
